import { push as updatePath } from 'react-router-redux';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { setPathToPurchaseTest } from 'helpers/pathToPurchaseHelper';
import { selectSubmittedOfferUrl } from 'redux/modules/offer';

export const redirectToNextStep = path => ({
  type: 'SIGNUP_CARD_REDIRECT_TO_NEXT_STEP',
  path,
});

export function* doRedirectToNextStep() {
  const resumeSignupLink = yield select(selectSubmittedOfferUrl);
  yield call(setPathToPurchaseTest);
  yield put(updatePath(resumeSignupLink));
}

export function* watchSignupCardSagas() {
  yield takeEvery(redirectToNextStep().type, doRedirectToNextStep);
}
